module.exports = __webpack_public_path__ + "img/hset_b13dda246.png";